import React, { useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import { IoClose, IoPrint, IoCloseCircle } from "react-icons/io5";
import { FaStore, FaReceipt, FaUser, FaPhone, FaCalendar, FaCreditCard } from "react-icons/fa";
import api from "./../../../utils/api";
import { showTranslatedValue, formatTime12Hour, showCurrencySymbol, getUserdata } from './../../../helper/generalHelper';

const ReceiptModal = ({ open, onClose, orderData }) => {
  const printRef = useRef();
  const [currentBusiness, setCurrentBusiness] = useState({});
  const [isPrinting, setIsPrinting] = useState(false);
  
  const userData = JSON.parse(localStorage.getItem("userData")) || {};
  const fName = userData.firstName || userData.first_name || userData.name || userData.username || "";
  const lName = userData.lastName || userData.last_name || "";
  const generatedBy = `${fName} ${lName}`.trim() || "Staff";

  const dateObj = new Date(orderData?.order_date || new Date());
  const shortDate = `${dateObj.getFullYear()}${String(dateObj.getMonth() + 1).padStart(2, '0')}${String(dateObj.getDate()).padStart(2, '0')}`;
  const shortId = orderData?.daily_order_number 
    ? `${shortDate}-${String(orderData.daily_order_number).padStart(3, '0')}`
    : `${shortDate}-${(orderData?.id || "").substring(0, 4).toUpperCase()}`;

  useEffect(() => {
    const fetchBusinesses = async () => {
      try {
        const isStaff = window.location.pathname.includes("/restaurant-staff/");
        const apiEndpoint = isStaff ? "restaurant-staff/restaurant/get" : "restaurant/restaurant/all";
        const res = await api.get(apiEndpoint);
        const activeRestaurantId = getUserdata("restaurantId");
        let activeBusiness = {};

        if (isStaff) {
          // Staff API returns a single object, not an array
          activeBusiness = res.data?.data || res.data?.restaurant || res.data || {};
          
          // Fallback to local session data if API mapping fails
          if (!activeBusiness.business_name) {
            activeBusiness = {
              business_name: getUserdata("restaurantName") || "",
              contact_number: getUserdata("restaurantPhone") || getUserdata("contact_number") || "",
              city: getUserdata("restaurantAddress") || getUserdata("city") || "",
            };
          }
        } else {
          if (res.data?.reataurants?.length > 0) {
            activeBusiness = res.data.reataurants.find(r => r.id == activeRestaurantId) || res.data.reataurants[0];
          }
        }
        
        setCurrentBusiness(activeBusiness);
        console.log(res?.data);
      } catch (error) {
        setCurrentBusiness({
          business_name: "",
          contact_number: "",
          address: ""
        });
      }
    };
    if (open) fetchBusinesses();
  }, [open]);

 const handlePrint = async () => {
  setIsPrinting(true);
  const order = orderData || {};
  const orderExtraTaxPercent = parseFloat(order.extra_tax_amout || order.extra_tax_amount || order.extra_tax || 0);
  const orderExtraTaxAmount = (parseFloat(order.subtotal || 0) * orderExtraTaxPercent) / 100;
  const win = window.open("", "_blank", "width=400,height=750");

  win.document.write(`
    <html>
      <head>
        <title>Receipt - ${currentBusiness.business_name || "A2Z"}</title>
        <style>
          body { font-family: Arial, sans-serif; margin: 20px; color: #000; }
          .header { text-align: center; margin-bottom: 20px; }
          .header h1 { margin: 0; font-size: 24px; font-weight: 900; }
          .header p { margin: 2px 0; font-size: 14px; font-weight: bold; color: #000; }
          table { width: 100%; border-collapse: collapse; margin-top: 15px; font-size: 14px; }
          th, td { padding: 6px; text-align: left; }
          th { border-bottom: 1px solid #ccc; }
          .right { text-align: right; }
          .bold { font-weight: bold; }
          .footer { text-align: center; margin-top: 20px; font-size: 14px; }
        </style>
      </head>
      <body>
        <div class="header">
          <h1>${currentBusiness.business_name || ""}</h1>
          <p>+91 ${currentBusiness.contact_number || ""}</p>
          <p>${currentBusiness.city || ""}</p>
        </div>
        
        <table>
          ${order.customer_name ? `<tr><td>Name</td><td class="right">${order.customer_name}</td></tr>` : ""}
          <tr><td>Receipt ID</td><td class="right">#${shortId}</td></tr>
          ${order.customer_mobile ? `<tr><td>Mobile No</td><td class="right">${order.customer_mobile}</td></tr>` : ""}
          ${order.customer_email ? `<tr><td>Email</td><td class="right">${order.customer_email}</td></tr>` : ""}
          <tr><td>Order Type</td><td class="right">${order.order_type === 'table' ? `Table - ${order.table_name || order.table_number || "Table"}` : (order.order_type || "Takeaway")}</td></tr>
          ${(order.payment_status == 17 || order.payment_status == '17') ? `<tr><td>Payment Mode</td><td class="right">${order.payment_mode || "UPI"}</td></tr>` : ""}
          <tr><td>Date & Time</td><td class="right">${order.order_date || "23 May 2024"} - ${formatTime12Hour(order.order_time) || "08:15 PM"}</td></tr>
        </table>

        <table>
          <thead>
            <tr>
              <th>Item Name</th>
              <th class="right">Item</th>
              <th class="right">Amount</th>
            </tr>
          </thead>
          <tbody>
            ${(order.order_details || [
              { menu: { title: "Ice Cream" }, quantity: 1, price: 19 },
              { menu: { title: "French Fries" }, quantity: 2, price: 55 },
            ])
              .map(
                (item) => `
              <tr>
                <td>
                  ${showTranslatedValue(item.menu,'title') || "Unknown"}
                  ${parseFloat(item.tax || item.menu?.tax || 0) > 0 ? `<br/><small style="color:gray;font-size:11px;">Tax (${parseFloat(item.tax || item.menu?.tax || 0).toFixed(2)}%): ${showCurrencySymbol(((item.price * item.quantity * parseFloat(item.tax || item.menu?.tax || 0)) / 100).toFixed(2))}</small>` : ''}
                  ${parseFloat(item.extra_tax || 0) > 0 ? `<br/><small style="color:gray;font-size:11px;">Tax (${parseFloat(item.extra_tax).toFixed(2)}%): ${showCurrencySymbol(((item.price * item.quantity * parseFloat(item.extra_tax)) / 100).toFixed(2))}</small>` : ''}
                  ${parseFloat(item.discount || 0) > 0 ? `<br/><small style="color:gray;font-size:11px;">Discount (${(item.discount_type?.toLowerCase() === 'percentage' || item.discount_type === '%') ? `${parseFloat(item.discount).toFixed(2)}%` : 'Fixed'}): -${showCurrencySymbol((item.discount_type?.toLowerCase() === 'percentage' || item.discount_type === '%') ? ((item.price * item.quantity * parseFloat(item.discount)) / 100).toFixed(2) : parseFloat(item.discount).toFixed(2))}</small>` : ''}
                  ${parseFloat(item.other_cost || 0) > 0 ? `<br/><small style="color:gray;font-size:11px;">Other Cost: ${showCurrencySymbol(parseFloat(item.other_cost).toFixed(2))}</small>` : ''}
                </td>
                <td class="right">${item.quantity}</td>
                <td class="right">${showCurrencySymbol(Number(item.price * item.quantity))}</td>
              </tr>
            `
              )
              .join("")}
          </tbody>
        </table>

        <table>
          <tr><td>Sub Total</td><td class="right">${showCurrencySymbol(order.subtotal || 0)}</td></tr>
          ${orderItemsTax > 0 ? `<tr><td>Item Tax</td><td class="right">${showCurrencySymbol(orderItemsTax.toFixed(2))}</td></tr>` : ""}
          ${orderItemsExtraTax > 0 ? `<tr><td>Item Tax</td><td class="right">${showCurrencySymbol(orderItemsExtraTax.toFixed(2))}</td></tr>` : ""}
          ${orderItemsOtherCost > 0 ? `<tr><td>Item Other Cost</td><td class="right">${showCurrencySymbol(orderItemsOtherCost.toFixed(2))}</td></tr>` : ""}
          ${orderItemsDiscount > 0 ? `<tr><td>Item Discount</td><td class="right">-${showCurrencySymbol(orderItemsDiscount.toFixed(2))}</td></tr>` : ""}
          ${parseFloat(order.tax_amount || 0) > 0 ? `<tr><td>Order Tax</td><td class="right">${showCurrencySymbol(order.tax_amount || 0)}</td></tr>` : ""}
          ${parseFloat(order.extra_discount_amount || 0) > 0 ? `<tr><td>Order Discount ${order.extra_discount_type ? `(${(order.extra_discount_type === '%' || order.extra_discount_type === 'percentage') ? `${parseFloat(order.extra_discount || 0)}%` : 'Fixed'})` : ''}</td><td class="right">-${showCurrencySymbol(order.extra_discount_amount || 0)}</td></tr>` : ""}
          ${orderExtraTaxAmount > 0 ? `<tr><td>Tax (${orderExtraTaxPercent}%)</td><td class="right">${showCurrencySymbol(orderExtraTaxAmount.toFixed(2))}</td></tr>` : ""}
          ${parseFloat(order.other_cost || 0) > 0 ? `<tr><td>${order.other_cost_type || "Other Cost"}</td><td class="right">${showCurrencySymbol(parseFloat(order.other_cost || 0).toFixed(2))}</td></tr>` : ""}
          <tr class="bold"><td>Grand Total</td><td class="right">${showCurrencySymbol(order.grand_total || 0)}</td></tr>
        </table>

        <div class="footer">
          <p>Thank You!</p>
          <p style="font-size: 11px; color: gray; margin-top: 10px;">Generated by: ${generatedBy}</p>
        </div>
      </body>
    </html>
  `);

  win.document.close();

  setTimeout(() => {
    win.focus();
    win.print();
    setIsPrinting(false);
  }, 500);
};


  if (!open) return null;

  const businessName = currentBusiness.business_name || "";
  const contact = currentBusiness.contact_number ? `+91 ${currentBusiness.contact_number}` : "";
  const address = currentBusiness.city || "";
  const order = orderData || {};

  const orderItemsTax = (order.order_details || []).reduce((acc, item) => {
    return acc + ((item.price * item.quantity * parseFloat(item.tax || item.menu?.tax || 0)) / 100);
  }, 0);
  const orderItemsExtraTax = (order.order_details || []).reduce((acc, item) => {
    return acc + ((item.price * item.quantity * parseFloat(item.extra_tax || 0)) / 100);
  }, 0);
  const orderItemsDiscount = (order.order_details || []).reduce((acc, item) => {
    const isPercent = item.discount_type?.toLowerCase() === 'percentage' || item.discount_type === '%';
    return acc + (isPercent ? ((item.price * item.quantity * parseFloat(item.discount || 0)) / 100) : parseFloat(item.discount || 0));
  }, 0);
  const orderItemsOtherCost = (order.order_details || []).reduce((acc, item) => {
    return acc + parseFloat(item.other_cost || 0);
  }, 0);

  const orderExtraTaxPercent = parseFloat(order.extra_tax_amout || order.extra_tax_amount || order.extra_tax || 0);
  const orderExtraTaxAmount = (parseFloat(order.subtotal || 0) * orderExtraTaxPercent) / 100;

  const modalContent = (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-[9999] p-2 sm:p-4 animate-fadeIn">
      <div className="w-full max-w-md bg-white rounded-3xl shadow-2xl overflow-hidden animate-scaleIn flex flex-col max-h-[95vh] sm:max-h-[90vh]">
        {/* Header */}
        <div className="flex-shrink-0">
          <div className="bg-white p-4 sm:p-6 sm:pb-4">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 sm:w-12 sm:h-12 bg-gradient-to-br from-red-100 to-orange-100 rounded-2xl flex items-center justify-center">
                  <FaStore className="text-xl sm:text-2xl text-red-500" />
                </div>
                <div>
                  <h2 className="text-lg sm:text-xl font-bold text-gray-900">Order Receipt</h2>
                  <p className="text-xs sm:text-sm text-gray-600">#{shortId}</p>
                </div>
              </div>
              <button
                onClick={onClose}
                className="p-2 hover:bg-gray-100 rounded-2xl transition-all duration-200 hover:scale-110"
              >
                <IoClose className="text-2xl text-gray-500 hover:text-red-500" />
              </button>
            </div>
          </div>
        </div>

        {/* Receipt Content */}
        <div className="px-4 sm:px-6 py-2 sm:py-4 overflow-y-auto flex-1 custom-scrollbar">
          <div ref={printRef} className="space-y-4 sm:space-y-6">
            {/* Business Header */}
            <div className="text-center mb-4 sm:mb-6">
              <h1 className="text-xl sm:text-2xl font-black bg-gradient-to-r from-gray-900 to-gray-700 bg-clip-text text-transparent">
                {businessName}
              </h1>
              <p className="text-gray-600 font-medium mt-1 text-sm sm:text-base">{contact}</p>
              <p className="text-gray-500 text-xs sm:text-sm mt-1">{address}</p>
            </div>

            {/* Order Information */}
            <div>
              <h3 className="flex items-center gap-2 text-base sm:text-lg font-bold text-gray-900 mb-2 sm:mb-3">
                <FaReceipt className="text-red-500" />
                Order Details
              </h3>
              <div className="space-y-2 sm:space-y-3">
                {order.customer_name && (
                  <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-3 text-xs sm:text-sm">
                    <div className="flex items-center gap-2">
                      <FaUser className="text-red-500 flex-shrink-0" />
                      <span className="text-gray-600 min-w-[90px] sm:min-w-[100px]">Customer:</span>
                    </div>
                    <span className="font-semibold text-gray-900 break-words">{order.customer_name}</span>
                  </div>
                )}
                {order.customer_mobile && (
                  <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-3 text-xs sm:text-sm">
                    <div className="flex items-center gap-2">
                      <FaPhone className="text-red-500 flex-shrink-0" />
                      <span className="text-gray-600 min-w-[90px] sm:min-w-[100px]">Mobile:</span>
                    </div>
                    <span className="font-semibold text-gray-900 break-words">{order.customer_mobile}</span>
                  </div>
                )}
                {order.customer_email && (
                  <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-3 text-xs sm:text-sm">
                    <div className="flex items-center gap-2">
                      <FaUser className="text-red-500 flex-shrink-0" />
                      <span className="text-gray-600 min-w-[90px] sm:min-w-[100px]">Email:</span>
                    </div>
                    <span className="font-semibold text-gray-900 break-words">{order.customer_email}</span>
                  </div>
                )}
                <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-3 text-xs sm:text-sm">
                  <div className="flex items-center gap-2">
                    <FaCreditCard className="text-red-500 flex-shrink-0" />
                    <span className="text-gray-600 min-w-[90px] sm:min-w-[100px]">Order Type:</span>
                  </div>
                  <span className="font-semibold text-gray-900 break-words">
                    {order.order_type === 'table' 
                      ? `Table - ${order.table_name || order.table_number || "Table"}` 
                      : (order.order_type || "Takeaway")}
                  </span>
                </div>
                {(order.payment_status == 17 || order.payment_status == '17') && (
                  <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-3 text-xs sm:text-sm">
                    <div className="flex items-center gap-2">
                      <FaCreditCard className="text-red-500 flex-shrink-0" />
                      <span className="text-gray-600 min-w-[90px] sm:min-w-[100px]">Payment Mode:</span>
                    </div>
                    <span className="font-semibold text-gray-900 uppercase break-words">
                      {order.payment_mode}
                    </span>
                  </div>
                )}
                <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-3 text-xs sm:text-sm">
                  <div className="flex items-center gap-2">
                    <FaCalendar className="text-red-500 flex-shrink-0" />
                    <span className="text-gray-600 min-w-[90px] sm:min-w-[100px]">Date & Time:</span>
                  </div>
                  <span className="font-semibold text-gray-900 break-words">
                    {(order.order_date || "23 May 2024")} - {formatTime12Hour(order.order_time) || "08:15 PM"}
                  </span>
                </div>
              </div>
            </div>

            <div className="border-t border-dashed border-gray-300 my-3 sm:my-4"></div>

            {/* Order Items */}
            <div>
              <h3 className="text-base sm:text-lg font-bold text-gray-900 mb-2 sm:mb-3">Order Items</h3>
              <div className="space-y-2 sm:space-y-3">
                {(order.order_details || [
                  { menu: { title: "Ice Cream" }, quantity: 1, unit: 1, price: 19 },
                  { menu: { title: "French Fries" }, quantity: 2, unit: 2, price: 55 },
                ]).map((item, index) => (
                  <div key={index} className="flex justify-between items-center p-2 sm:p-3 bg-gray-50 rounded-lg">
                    <div className="flex-1 min-w-0 pr-2">
                      <div className="font-semibold text-gray-900 text-sm sm:text-base break-words">
                        {showTranslatedValue(item.menu,"title") || item.menu_id || "Unknown Item"}
                      </div>
                      <div className="text-xs sm:text-sm text-gray-600">
                        Qty: {item.quantity} × {showCurrencySymbol(item.price)}
                      </div>
                      {parseFloat(item.tax || item.menu?.tax || 0) > 0 && (
                        <div className="text-xs text-gray-500 mt-0.5">
                          Tax ({parseFloat(item.tax || item.menu?.tax || 0).toFixed(2)}%): {showCurrencySymbol(((item.price * item.quantity * parseFloat(item.tax || item.menu?.tax || 0)) / 100).toFixed(2))}
                        </div>
                      )}
                      {parseFloat(item.extra_tax || 0) > 0 && (
                        <div className="text-xs text-gray-500 mt-0.5">
                          Tax ({parseFloat(item.extra_tax).toFixed(2)}%): {showCurrencySymbol(((item.price * item.quantity * parseFloat(item.extra_tax)) / 100).toFixed(2))}
                        </div>
                      )}
                      {parseFloat(item.discount || 0) > 0 && (
                        <div className="text-xs text-gray-500 mt-0.5">
                          Discount ({(item.discount_type?.toLowerCase() === 'percentage' || item.discount_type === '%') ? `${parseFloat(item.discount).toFixed(2)}%` : 'Fixed'}): -{showCurrencySymbol((item.discount_type?.toLowerCase() === 'percentage' || item.discount_type === '%') ? ((item.price * item.quantity * parseFloat(item.discount)) / 100).toFixed(2) : parseFloat(item.discount).toFixed(2))}
                        </div>
                      )}
                      {parseFloat(item.other_cost || 0) > 0 && (
                        <div className="text-xs text-gray-500 mt-0.5">
                          Other Cost: {showCurrencySymbol(parseFloat(item.other_cost).toFixed(2))}
                        </div>
                      )}
                    </div>
                    <div className="font-bold text-green-600 text-sm sm:text-base flex-shrink-0">
                      {showCurrencySymbol(Number(item.price * item.quantity))}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="border-t border-dashed border-gray-300 my-3 sm:my-4"></div>

            {/* Order Summary */}
            <div className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-2xl p-3 sm:p-4">
              <h3 className="text-base sm:text-lg font-bold text-gray-900 mb-2 sm:mb-3">Order Summary</h3>
              <div className="space-y-1 sm:space-y-2 text-sm sm:text-base">
                <div className="flex justify-between">
                  <span className="text-gray-600">Sub Total:</span>
                  <span className="font-semibold">{showCurrencySymbol(order.subtotal || 0)}</span>
                </div>
                {orderItemsTax > 0 && (
                  <div className="flex justify-between">
                    <span className="text-gray-600">Item Tax:</span>
                    <span className="font-semibold">{showCurrencySymbol(orderItemsTax.toFixed(2))}</span>
                  </div>
                )}
                {orderItemsExtraTax > 0 && (
                  <div className="flex justify-between">
                    <span className="text-gray-600">Item Tax:</span>
                    <span className="font-semibold">{showCurrencySymbol(orderItemsExtraTax.toFixed(2))}</span>
                  </div>
                )}
                {orderItemsOtherCost > 0 && (
                  <div className="flex justify-between">
                    <span className="text-gray-600">Item Other Cost:</span>
                    <span className="font-semibold">{showCurrencySymbol(orderItemsOtherCost.toFixed(2))}</span>
                  </div>
                )}
                {orderItemsDiscount > 0 && (
                  <div className="flex justify-between text-red-600">
                    <span>Item Discount:</span>
                    <span className="font-semibold">-{showCurrencySymbol(orderItemsDiscount.toFixed(2))}</span>
                  </div>
                )}
                {parseFloat(order.tax_amount || 0) > 0 && (
                  <div className="flex justify-between">
                    <span className="text-gray-600">Order Tax:</span>
                    <span className="font-semibold">{showCurrencySymbol(order.tax_amount || 0)}</span>
                  </div>
                )}
                {parseFloat(order.extra_discount_amount || 0) > 0 && (
                  <div className="flex justify-between text-red-600">
                    <span>Order Discount {order.extra_discount_type ? `(${(order.extra_discount_type === '%' || order.extra_discount_type === 'percentage') ? `${parseFloat(order.extra_discount || 0)}%` : 'Fixed'})` : ''}:</span>
                    <span className="font-semibold">-{showCurrencySymbol(order.extra_discount_amount || 0)}</span>
                  </div>
                )}
                {orderExtraTaxAmount > 0 && (
                  <div className="flex justify-between">
                    <span className="text-gray-600">Tax ({orderExtraTaxPercent}%):</span>
                    <span className="font-semibold">{showCurrencySymbol(orderExtraTaxAmount.toFixed(2))}</span>
                  </div>
                )}
                {parseFloat(order.other_cost || 0) > 0 && (
                  <div className="flex justify-between">
                    <span className="text-gray-600">{order.other_cost_type || "Other Cost"}:</span>
                    <span className="font-semibold">{showCurrencySymbol(parseFloat(order.other_cost || 0).toFixed(2))}</span>
                  </div>
                )}
                <div className="border-t border-gray-300 pt-2 mt-2">
                  <div className="flex justify-between text-base sm:text-lg font-bold">
                    <span className="text-gray-900">Grand Total:</span>
                    <span className="text-green-600">{showCurrencySymbol(order.grand_total || 0)}</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Footer */}
            <div className="text-center py-2 sm:py-4 border-t border-dashed border-gray-300 mt-2 pt-4">
              <div className="text-base sm:text-lg font-black text-gray-900 mb-1">Thank You!</div>
              <div className="text-xs sm:text-sm text-gray-600">We hope to see you again soon</div>
              <div className="text-[10px] text-gray-400 mt-2 font-medium">Generated by: {generatedBy}</div>
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex-shrink-0 px-4 sm:px-6 py-3 sm:py-4 bg-gray-50 border-t border-gray-200">
          <div className="flex gap-2 sm:gap-3">
            <button
              onClick={handlePrint}
              disabled={isPrinting}
              className="flex-1 bg-primary text-white font-semibold py-2 sm:py-3 px-4 sm:px-6 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2 text-sm sm:text-base"
            >
              <IoPrint className="text-lg" />
              <span className="hidden sm:inline">{isPrinting ? "Printing..." : "Print Receipt"}</span>
              <span className="sm:hidden">{isPrinting ? "Wait..." : "Print"}</span>
            </button>
            <button
              onClick={onClose}
              className="flex-1 bg-gray-200 text-gray-700 font-semibold py-2 sm:py-3 px-4 sm:px-6 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-200 hover:bg-gray-300 flex items-center justify-center gap-2 text-sm sm:text-base"
            >
              <IoCloseCircle className="text-lg" />
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );

  return ReactDOM.createPortal(modalContent, document.body);
};

export default ReceiptModal;